import { useContext } from 'react'
import { ApiContext } from './ApiContext'
import { type ApiContextBag } from './types'

export const useApiContext = () => useContext<ApiContextBag>(ApiContext)
